var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uni-countdown"},[(_vm.showDay)?_c('span',{staticClass:"uni-countdown__number",style:({
      borderColor: _vm.borderColor,
      color: _vm.color,
      backgroundColor: _vm.backgroundColor
    })},[_vm._v(_vm._s(_vm.d))]):_vm._e(),(_vm.showDay)?_c('span',{staticClass:"uni-countdown__splitor",style:({ color: _vm.splitorColor })},[_vm._v("天")]):_vm._e(),_c('span',{staticClass:"uni-countdown__number",style:({
      borderColor: _vm.borderColor,
      color: _vm.color,
      backgroundColor: _vm.backgroundColor
    })},[_vm._v(_vm._s(_vm.h))]),_c('span',{staticClass:"uni-countdown__splitor",style:({ color: _vm.splitorColor })},[_vm._v(_vm._s(_vm.showColon ? ":" : "时"))]),_c('span',{staticClass:"uni-countdown__number",style:({
      borderColor: _vm.borderColor,
      color: _vm.color,
      backgroundColor: _vm.backgroundColor
    })},[_vm._v(_vm._s(_vm.i))]),_c('span',{staticClass:"uni-countdown__splitor",style:({ color: _vm.splitorColor })},[_vm._v(_vm._s(_vm.showColon ? ":" : "分"))]),_c('span',{staticClass:"uni-countdown__number",style:({
      borderColor: _vm.borderColor,
      color: _vm.color,
      backgroundColor: _vm.backgroundColor
    })},[_vm._v(_vm._s(_vm.s))]),(!_vm.showColon)?_c('span',{staticClass:"uni-countdown__splitor",style:({ color: _vm.splitorColor })},[_vm._v("秒")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }